// extracted by css-extract-rspack-plugin
export default {"root":"sfBees","left":"GiUskU","right":"FqMWaD","author":"ZYxdgF","actions":"CHhVGZ"};